export default __webpack_public_path__ + "static/media/reactFlowHighlevel.cb6d0956.png";